<template>
  <div class="info-display-three" style="width: 100%">
    <div class="image">
      <img :src="itemData.img">
      <!-- <div class="image-circle">
        <img>
      </div> -->
      <h4>{{ itemData.name }}</h4>
    </div>
  </div>
</template>

<script>
import { db } from '@/firebase'
export default {
  props: ['itemid'],
  firebase: function () {
    return {
      itemData: {
        source: db.ref('attributes/skills/' + this.itemid),
        asObject: true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Skill.vue?2ccf90da